import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { Loading } from '../../components/shared/Loading'

import styles from './Scroll.module.scss'


type ScrollProps<T> = {
  options: T[]
  getOptionComponent: (item: T) => JSX.Element
  getOptionKey: (item: T) => string
  variant?: 'dropdown'
          | 'secondary'
          | 'transparent'
  handleFetch?: () => void
  hasMoreData?: boolean
  height?: string
  finalText?: string
  bottomoSpace?: string
}


export const Scroll = <T, >({
  options,
  getOptionComponent,
  getOptionKey,
  variant = 'secondary',
  handleFetch = () => null,
  hasMoreData = false,
  height,
  finalText,
  bottomoSpace
}: ScrollProps<T>) => (
  <div
    id='scrollableDiv'
    className={`
      ${styles.scroll}
      ${variant !== 'transparent' && styles.container}
      ${variant === 'dropdown' && styles.dropdown}
    `}
    style={{ height: height === '100%' ? height : undefined }}
  >
    <InfiniteScroll
      className={styles.infinityScroll}
      // eslint-disable-next-line i18next/no-literal-string
      scrollableTarget={height === "100%" ? 'scrollableDiv' : undefined}
      height={height === "100%" ? undefined : height}
      dataLength={options.length}
      next={handleFetch}
      hasMore={hasMoreData}
      inverse
      loader={(
        <Loading
          marginTop='1rem'
          marginBottom='1rem'
        />
      )}
      endMessage={
        <p className={styles.finalText}>
          <b>
            {finalText}
          </b>
        </p>
      }
    >
      <ul>
        {options.map((opt: T) => (
          <li
            key={`scrollOption_${getOptionKey(opt)}`}
            className={styles.item}
          >
            {getOptionComponent(opt)}
          </li>
        ))}
        {bottomoSpace && <li style={{ height: bottomoSpace }} />}
      </ul>
    </InfiniteScroll>
  </div>
)
